module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-LightItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-LightItalic.ttf
// module id = 1903
// module chunks = 0